import React, { FunctionComponent } from 'react';

import { SingleFieldStepProps, InsuredItem } from 'scenes/common/types';
import SingleYesNoStep from 'scenes/common/components/Steps/SingleYesNoStep';

export const STATE_KEY = 'ownedProperty';
export const HELP_TEXT =
  'Answer "Yes" even if you have an outstanding home loan over the property';

const OwnershipStep: FunctionComponent<
  Pick<SingleFieldStepProps<string>, 'defaultStateValue' | 'onNext'> & {
    insuredItem: InsuredItem;
  }
> = ({ defaultStateValue, onNext, insuredItem }) => (
  <SingleYesNoStep
    onNext={onNext}
    question={`Do you own the ${insuredItem}?`}
    stateKey={STATE_KEY}
    defaultStateValue={defaultStateValue}
  />
);

export default OwnershipStep;
